import { getRequest } from '../services/requestHandler';
import { ShaftTippingFraction } from '../models';

export const getShaftTippingFraction = async () => {
  const url = 'shaftfraction/GetShaftTippingFraction';
  const response = await getRequest<ShaftTippingFraction>('getShaftTippingFraction', url);
  return response;
};
